import DynamicPageView from "views/common/DynamicPageView";
import ti18n from "i18n!nls/UserChangePasswordi18n";
import PersistentModels from "services/PersistentModels";
import PublicResetPasswordPageTemplate from 'text!../../../templates/user/PublicResetPasswordPageTemplate.html';
import Mousetrap from 'mousetrap';

const PublicResetPasswordPageView = DynamicPageView.extend({

initialize : function(options) {
    const dynamicPageOptions = {};
    this.model =  options ? options.model : {};
    this._pageId = (options && options.pageId) ? options.pageId : "publicResetPasswordPage";
    dynamicPageOptions.pageViewTemplate = PublicResetPasswordPageTemplate;
    dynamicPageOptions.model = this.model;
    dynamicPageOptions.pageId = this._pageId;
    dynamicPageOptions.headerFullscren = true;
    dynamicPageOptions.persistent = true;
    dynamicPageOptions.onPageShow = this.onPageShow.bind(this);
    dynamicPageOptions.pageTemplateOptions = {"ti18n": ti18n};
    return DynamicPageView.prototype.initialize.call(this, dynamicPageOptions);
},

events : {
    "click #header-back-button" : "navigateToLoginPage",
    "click #saveButtonIcon:not(.disabled)" : "saveChanges",
    "click #saveNewPasswordBtn:not(.disabled)" : "saveChanges",
},

saveChanges : function(){
    this.trigger("saveChanges", this.getPasswordData());
    this.setSaveButtonEnabled(false);
},

getPasswordData: function(){
    const data = {};
    data.newPassword  = this.newPassswordField$el.get(0).value;
    data.reenterNewPassword  = this.reenterNewPassswordField$el.get(0).value;
    return data;
},

onFieldValueChanged : function(){
    this.setSaveButtonEnabled(this.isAllMandatoryFieldsFilled());
},

isAllMandatoryFieldsFilled : function(){
    return this.validatePasswordField();
},

validateReenterPasswordField : function(){
    const passwordInput = this.newPassswordField$el.get(0);
    const pass2 = this.reenterNewPassswordField$el.get(0).value;
    const pass1 = passwordInput.value;
    const arePasswordTheSame = pass1 === pass2;

    if (!arePasswordTheSame) {
        this.reenterNewPassswordFieldDec$el.find("label").attr("data-error", window.getI18n(ti18n, "PASSWORD_DONT_MATCH"));
        if(!this.reenterNewPassswordField$el.hasClass("invalid")){
            this.reenterNewPassswordField$el.addClass("invalid");
        }
    } else {
        this.reenterNewPassswordField$el.removeClass("invalid");
        this.reenterNewPassswordFieldDec$el.find("label").attr("data-error","");
    }

    return arePasswordTheSame;
},

validatePasswordField : function(){
    const pass1 = this.newPassswordField$el.get(0).value;
    const isNewPasswordValid = /^.{6,20}$/.test(pass1);

    if (!isNewPasswordValid) {
        this.newPassswordFieldDec$el.find("label").attr("data-error", window.getI18n(ti18n, "PASSWORD_MUST_BE_BETWEEN_X_CHARS"));
        if(!this.newPassswordField$el.hasClass("invalid")){
            this.newPassswordField$el.addClass("invalid");
        }
    } else {
        this.newPassswordField$el.removeClass("invalid");
        this.newPassswordFieldDec$el.find("label").attr("data-error","");
    }

    return isNewPasswordValid && this.validateReenterPasswordField();
},

navigateToLoginPage : function(){
    if(PersistentModels.getInstance().getRouter()){
        PersistentModels.getInstance().getRouter().showNewLoginPage(true);
    }else{
        window.location.assign(window.getAppBaseUrl() + "#NewLoginPage");
    }
},

setSaveButtonEnabled : function(enabled){
    const buttons$el = this.saveButtons$el || this.saveButton$el;
    if(!buttons$el){
        return;
    }
    if(enabled){
        buttons$el.removeClass("disabled");
    }else{
        buttons$el.not(".disabled").addClass("disabled");
    }
},

onAfterPageInitialized : function(){
    this.saveButton$el  = this.$el.find("#saveButtonIcon");
    this.saveNewPasswordBtn$el = this.$el.find("#saveNewPasswordBtn");
    this.saveButtons$el = this.saveButton$el.add(this.saveNewPasswordBtn$el);
    this.newPassswordField$el = this.$el.find("#passwordField");
    this.reenterNewPassswordField$el = this.$el.find("#reenterPasswordField");
    this.newPassswordFieldDec$el = this.$el.find("#passwordDecId");
    this.reenterNewPassswordFieldDec$el = this.$el.find("#reenterPasswordDecId");
    this.$el.find("#passwordChangeFormWrapper").on("click blur keyup input", this.onFieldValueChanged.bind(this));
    this.onFieldValueChanged();
    this.setSaveButtonEnabled(false);
    this.$el.on("pagehide", this._onPageHide.bind(this));
    this._bindSaveShortcut();
    this._updateViewportHeightVar();
    this._viewportHeightListener = this._updateViewportHeightVar.bind(this);
    window.addEventListener("resize", this._viewportHeightListener);
    if(window.visualViewport){
        window.visualViewport.addEventListener("resize", this._viewportHeightListener);
    }
},

_updateViewportHeightVar : function(){
    if(typeof window === "undefined" || !window.document || !window.document.documentElement){
        return;
    }
    const viewportHeight = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    window.document.documentElement.style.setProperty("--vh", (viewportHeight * 0.01) + "px");
},

onPageShow : function(){
    // Persistent view: the Enter shortcut is unbound in _onPageHide and
    // must be reattached each time the page is shown again.
    this._bindSaveShortcut();
    this.trigger("pageShow");
},

_bindSaveShortcut : function(){
    const wrapperEl = this.$el.find("#passwordChangeFormWrapper").get(0);
    if(!wrapperEl){
        return;
    }
    if(this._mousetrapObj && typeof this._mousetrapObj.unbind === "function"){
        this._mousetrapObj.unbind("enter");
    }
    this._mousetrapObj = Mousetrap(wrapperEl).bind('enter', (function() {
        const enabledSaveButtons$el = (this.saveButtons$el || this.saveButton$el).not(".disabled");
        if(enabledSaveButtons$el && enabledSaveButtons$el.length > 0){
            this.saveChanges();
        }
    }).bind(this));
},

_onPageHide : function(){
    if(this._mousetrapObj && typeof this._mousetrapObj.unbind === "function"){
        this._mousetrapObj.unbind("enter");
    }
},

onBeforeRemoveFromPage : function(){
    DynamicPageView.prototype.onBeforeRemoveFromPage.call(this);
    const router = PersistentModels.getInstance().getRouter();
    if(router){
        router.unRegisterForViewportHeightChange(this._pageId);
    }
    if(this._viewportHeightListener){
        window.removeEventListener("resize", this._viewportHeightListener);
        if(window.visualViewport){
            window.visualViewport.removeEventListener("resize", this._viewportHeightListener);
        }
        this._viewportHeightListener = null;
    }
},

});
export default PublicResetPasswordPageView;
